/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {combineReducers} from 'redux'
import {TypedUseSelectorHook, useSelector} from 'react-redux'
import ArticlesReducer from 'store/articles/ArticlesReducer'
import BookingReducer from 'store/booking/BookingReducer'
import SessionReducer from 'store/session/SessionReducer'
import HallReducer from 'store/hall/HallReducer'
import VoucherReducer from 'store/shop/VoucherReducer'
import BookingLoginReducer from 'store/bookingLogin/BookingLoginReducer'
import SellerReducer from 'store/seller/SellerReducer'
import ReservationsReducer from 'store/reservations/ReservationsReducer'
import CompaniesReducer from 'store/companies/CompaniesReducer'
import LeadsReducer from 'store/leads/LeadsReducer'
import OffersReducer from 'store/offers/OffersReducer'
import TemplatesReducer from 'store/templates/TemplatesReducer'
import ContactsReducer from 'store/contacts/ContactsReducer'
import CalendarReducer from 'store/calendar/CalendarReducer'
import SettingsReducer from 'store/settings/SettingsReducer'
import ReservationReducer from 'store/reservation/ReservationReducer'
import ShopReducer, {ShopState} from 'store/shop/ShopReducer'
import CommonReducer from 'store/common/CommonReducer'
import UiReducer from 'store/ui/UiReducer'
import RemindersReducer from 'store/reminders/RemindersReducer'
import OpportunitiesReducer from 'store/opportunities/OpportunitiesReducer'
import EmailTemplatesReducer from 'store/emailTemplates/EmailTemplatesReducer'
import OnlineReservationsReducer from "store/reservations/OnlineReservationsReducer";
import TableViewsReducer from 'store/tableViews/TableViewsReducer'
import CrmReducer from 'store/crm/CrmReducer'

export type { ShopState }

const reducers = combineReducers(
    /*<State>*/ {
        common: CommonReducer,
        ui: UiReducer,
        reservation: ReservationReducer,
        shop: ShopReducer,
        articlesState: ArticlesReducer,
        bookingState: BookingReducer,
        bookingLoginState: BookingLoginReducer,
        voucherState: VoucherReducer,
        seller: SellerReducer,
        reservationsState: ReservationsReducer,
        onlineReservationsState: OnlineReservationsReducer,
        companiesState: CompaniesReducer,
        leadsState: LeadsReducer,
        opportunitiesState: OpportunitiesReducer,
        offersState: OffersReducer,
        templatesState: TemplatesReducer,
        contactsState: ContactsReducer,
        calendar: CalendarReducer,
        settings: new SettingsReducer().reducer,
        hallState: HallReducer,
        sessionState: SessionReducer,
        remindersState: RemindersReducer,
        emailTemplatesState: EmailTemplatesReducer,
        tableViewsState: TableViewsReducer,
        crmState: CrmReducer,
    }
)

export type RootState = ReturnType<typeof reducers>
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector

export default reducers
